import PropTypes from 'prop-types'

import CoverHighlight from 'components/CoverHighlight'

function HighlightBlock({ highlight = {} }) {
  return <CoverHighlight cover={highlight} />
}

HighlightBlock.propTypes = {
  highlight: PropTypes.object,
}

export default HighlightBlock
